import React from "react";

interface Props {
    size?: number,
    color?: string,
}

const SvgTwitter = ({size = 16, color = '#FFF'}: Props) => (
    <svg width={size} height={size} viewBox="0 0 16 16">
        <path
            fill={color}
            d="M16 3.421a6.839 6.839 0 01-1.89.518 3.262 3.262 0 001.443-1.813 6.555 6.555 0 01-2.08.794 3.28 3.28 0 00-5.674 2.243c0 .26.022.51.076.748a9.287 9.287 0 01-6.761-3.43 3.285 3.285 0 001.008 4.383A3.24 3.24 0 01.64 6.46v.036a3.295 3.295 0 002.628 3.223 3.274 3.274 0 01-.86.108 2.9 2.9 0 01-.621-.056 3.31 3.31 0 003.065 2.285A6.592 6.592 0 010 13.41a9.234 9.234 0 005.032 1.472c6.036 0 9.336-5 9.336-9.334 0-.145-.005-.285-.012-.424A6.544 6.544 0 0016 3.421z"
        />
    </svg>
);

export default SvgTwitter;